/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-empty-function */
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Button, Group, Space } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useModals } from '@mantine/modals';
import { EntityEquipmentType, EntityType } from '../../../../../../../models/core/entities.type';
import EquipmentFormViewActions from './EquipmentFormViewActions';
import EquipmentFormAddEdit from './EquipmentFormAddEdit';
import { Feature, SessionStorageKey } from '../../../../../../../utils/constants.utils';
import PageSection from '../../../../../../../components/core/PageSection/PageSection';
import { Action } from '../../../../../../../models/core/core.type';

type FormViewProps = {
  entity: EntityType | null;
  zIndex: number;
};

const EquipmentFormView = forwardRef((props: FormViewProps, ref) => {
  const modals = useModals();

  const [data, setData] = useState<EntityEquipmentType[]>(
    props.entity?.residuoEquipamentos.map((x) => {
      return {
        ...x,
        action: Action.Nothing,
        id: x.idEntidadeResiduoEquipamento?.toString() || '',
      };
    }) || []
  );

  const columns: ColumnsType<any> = [
    {
      title: 'Equipamento',
      key: 'residuoEquipamento',
      dataIndex: 'residuoEquipamento',
      sorter: (a: EntityEquipmentType, b: EntityEquipmentType) =>
        a.residuoEquipamento.localeCompare(b.residuoEquipamento),
    },
    {
      title: 'Descrição',
      key: 'residuoEquipamentoDescricao',
      sorter: (a: EntityEquipmentType, b: EntityEquipmentType) =>
        (a.residuoEquipamentoDescricao || '').localeCompare(b.residuoEquipamentoDescricao || ''),
      render: (row: EntityEquipmentType) => <div>{row?.residuoEquipamentoDescricao || '-'}</div>,
    },
    {
      title: 'Tipo',
      key: 'proprio',
      sorter: (a: EntityEquipmentType, b: EntityEquipmentType) =>
        a.proprio === b.proprio ? 0 : a.proprio ? -1 : 1,
      render: (row: EntityEquipmentType) => <div>{row?.proprio ? 'Próprio' : 'Terceirizado'}</div>,
    },
    {
      title: 'Ações',
      width: '100px',
      render: (row: EntityEquipmentType) => (
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        <EquipmentFormViewActions item={row} confirmActionResult={confirmActionResult} />
      ),
    },
  ];

  const confirmActionResult = (item: EntityEquipmentType | null, action: string, confirmed: boolean) => {
    if (!confirmed) {
      return;
    }

    let dataItemIndex;
    let dataItem;

    switch (action) {
      case 'excluir':
        dataItemIndex = data.findIndex((x) => x.id === item?.id);
        if (dataItemIndex > -1) {
          dataItem = data[dataItemIndex];
          if (dataItem.idEntidadeResiduoEquipamento) {
            data[dataItemIndex] = { ...dataItem, action: Action.Delete };
          } else {
            data.splice(dataItemIndex, 1);
          }
          setData(JSON.parse(JSON.stringify(data)));
        }
        break;
      case 'editar':
      case 'adicionar':
        modals.openModal({
          title: `Equipamento - ${item ? 'Editar' : 'Adicionar'}`,
          size: 'xl',
          closeOnClickOutside: false,
          children: (
            <EquipmentFormAddEdit
              items={data}
              origItem={
                item
                  ? props.entity?.residuoEquipamentos.find(
                      (x) => x.idEntidadeResiduoEquipamento === item.idEntidadeResiduoEquipamento
                    ) || null
                  : null
              }
              item={item}
              idEntidade={props.entity?.idEntidade}
              callback={confirmActionResult}
              zIndex={props.zIndex + 1}
            />
          ),
        });
        break;
      case 'callback':
        modals.closeAll();
        dataItemIndex = data.findIndex((x) => x.id === item?.id);
        if (dataItemIndex > -1) {
          dataItem = data[dataItemIndex];
          data[dataItemIndex] = { ...dataItem, ...item };
        } else {
          data.push(item!);
        }
        setData(data);
        break;
      default:
        break;
    }
  };

  useImperativeHandle(ref, () => ({
    validate(): EntityEquipmentType[] {
      return data;
    },
    clear() {
      setData([]);
    },
  }));

  useEffect(() => {
    const tempEntity = JSON.parse(sessionStorage.getItem(SessionStorageKey.TempEntity) || 'null');
    if (tempEntity) {
      setData(tempEntity.residuoEquipamentos);
    }
  }, []);

  return (
    <div>
      <Group justify="space-between">
        <PageSection size="lg" color={Feature.Reference.Entity.color} label="Equipamentos" text="" />
        <Button
          color="primary"
          leftSection={<IconPlus size={18} />}
          onClick={() => {
            confirmActionResult(null, 'adicionar', true);
          }}
        >
          Adicionar
        </Button>
      </Group>
      <Space h="xs" />
      <Table
        showSorterTooltip={false}
        dataSource={data.filter((x) => x.action !== Action.Delete)}
        columns={columns}
        rowKey={(item: EntityEquipmentType) => item.id || 0}
        pagination={{
          pageSizeOptions: [10, 25, 50],
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]} - ${range[1]} de ${total} resultado(s)`,
        }}
      />
    </div>
  );
});

export default EquipmentFormView;
